function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Text, Flex } from "sprout-ui-primitives";
import { getItemUrl } from "sprout-lib";
import { useNavigationList, useNavigationListItem } from "@sprout/list-navigation";
import { Link } from "react-router-dom";
import styled from "styled-components";
const TopicPageSectionSectionsSection = (props)=>{
    const { section , index , owner , overrideTitle  } = props;
    const { navProps , helpers: navigationItemHelpers  } = useNavigationListItem(section.nodeId, useMemo(()=>({
            index,
            object: section
        }), [
        index,
        section
    ]));
    const { isActive  } = navigationItemHelpers;
    return /*#__PURE__*/ _jsx(Flex, _objectSpread({
        maxWidth: "300px",
        flexDirection: "column"
    }, navProps, {
        bg: isActive ? "#c5d2e0" : "blue.50",
        minWidth: "32px",
        borderRadius: "32px",
        children: /*#__PURE__*/ _jsx(Text, {
            as: Link,
            to: getItemUrl(section, owner),
            textAlign: "center",
            fontSize: 2,
            lineHeight: "32px",
            fontWeight: "medium",
            truncate: true,
            px: 1,
            children: overrideTitle || section.title || "No title"
        })
    }));
};
const TopicPageSectionSectionsWrapper = styled(Flex)`
  > * {
    margin-right: 8px;
    margin-bottom: 4px;
  }

  margin-bottom: -4px;
`;
const TopicPageSectionSections = (props)=>{
    const { sections , parentTopic , owner , excessSectionsCount  } = props;
    const { Provider , navProps  } = useNavigationList(`TopicPage_Section_Sections|${parentTopic.nodeId}`, useMemo(()=>({}), []));
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsxs(TopicPageSectionSectionsWrapper, _objectSpread({}, navProps, {
            flexWrap: "wrap",
            py: 2,
            children: [
                sections.map((section, index)=>{
                    return /*#__PURE__*/ _jsx(TopicPageSectionSectionsSection, {
                        owner: owner,
                        section: section,
                        index: index
                    }, section.nodeId);
                }),
                excessSectionsCount > 0 && /*#__PURE__*/ _jsx(TopicPageSectionSectionsSection, {
                    owner: owner,
                    section: parentTopic,
                    index: sections.length,
                    overrideTitle: `+${excessSectionsCount}`
                })
            ]
        }))
    });
};
export default TopicPageSectionSections;
